import { Box, Card, styled } from '@mui/material';

const StyledRoot = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: '12px',
  padding: '1rem',
  boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  boxSizing: 'border-box',
}));

const Wrapper = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

const StyledCard = styled(Card)({
  boxShadow: 'none',
  borderRadius: 0,
  backgroundColor: 'transparent',
  flex: 1,
  overflow: 'visible',
  display: 'flex',
  flexDirection: 'column',
});

const StyledTypography = styled('h3')({
  textWrap: 'nowrap',
});

const TitleWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  flex: 1,
});

export { StyledRoot, StyledCard, StyledTypography, TitleWrapper, Wrapper };
